import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const tareaImporterSelectors = importerSelectors(
  'tarea.importer',
);

export default tareaImporterSelectors;
